import Button from "@mui/material/Button"
import { Grid2 as Grid } from "@mui/material"
import { Formik, Field } from "formik"
import { Documento } from "../../types"
import { useMemo } from "react"
import * as yup from "yup"
import { transformErrorForForm } from "../../utils/utils"
import { FormikDatePicker, FormikTextField } from "./formsHelpers"
import { FormInDialogEditProps } from "../DialogForm"
import { useTranslation } from "react-i18next"
import { ACSupportoMulti, ACVocabolarioMulti } from "./autocompletes"

export default function DocumentoForm({ item, save, ref }: FormInDialogEditProps<Documento>) {
  const { t } = useTranslation()

  const schema = useMemo(
    () =>
      yup.object().shape({
        // titolo_attribuito: yup.string().test(function (value) {
        //   const { titolo_proprio } = this.parent;
        //   if (!titolo_proprio) return value != null
        //   return true
        // }).required(t("documento.titolo_attribuito_or_proprio_required")),
        // titolo_proprio: yup
        //   .string()
        //   .test(function (value) {
        //     const { titolo_attribuito } = this.parent
        //     if (!titolo_attribuito) return value != null
        //     return true
        //   })
        //   .required(t("documento.titolo_attribuito_or_proprio_required")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={
        item || {
          titolo_proprio: "",
          complemento_titolo: "",
          titolo_attribuito: "",
          note_titolo: "",
          abstract: "",
          notizie_stor_critiche: "",
          vincoli_modalita_consultazione: "",
          copyright: "",
          bibliografia_sitografia: "",
          limiti_utilizzo: false,
          data_produzione: null,
          supporti: [],
        }
      }
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Documento).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue, setFieldTouched }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={4}>
                <Field
                  component={FormikDatePicker}
                  name="data_produzione"
                  label={t("documento.data_produzione")}
                  margin="dense"
                  type="date"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  type="number"
                  name="cronologia_da"
                  label={t("documento.cronologia_da")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  type="number"
                  name="cronologia_a"
                  label={t("documento.cronologia_a")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="titolo_proprio"
                  label={t("documento.titolo_proprio")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="complemento_titolo"
                  label={t("documento.complemento_titolo")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                />
              </Grid>
 
              <Grid size={12}>
                <ACVocabolarioMulti
                  label={t("fondo.genere")}
                  vocabolario="fondo_genere"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.genere as number[]}
                  onChange={(value) => {
                    setFieldValue("genere", value)
                  }}
                  onBlur={() => {
                    setFieldTouched("genere", true)
                  }}
                />
              </Grid>

              <Grid size={12}>
                <ACSupportoMulti
                  label={t("general.supporti")}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.supporti || []}
                  onChange={(value) => {
                    setFieldValue("supporti", value)
                  }}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
